function handleCustomerForms() {
  const forms = document.querySelectorAll('form:has([name="contact[email]"])');
  forms?.forEach((form) => {
    form.addEventListener("submit", (e) => {
      let submitDetails = true;
      if(window.location.pathname.includes('challenge')) submitDetails = false;
      const hCaptcha = e.target.querySelector("textarea[name=h-captcha-response]")?.value;
      if (submitDetails || (hCaptcha && window.location.pathname.includes('challenge'))) {
        const email = e.target.querySelector('[name="contact[email]"]')?.value;
        const cordialAuth = "NjNlMTU4MTkxMjgxMzFlMTNlMGVjYjE4LW9hWHhzWGdJempmRERBNkJpcVBoSnd1Mzg5UTlBOWZJOg==";
        const cordialBody = {
          channels: {
            email: {
              address: email,
              subscribeStatus: "subscribed",
            },
          },
          identifyBy: ["email"],
          forceSubscribe: true,
        };

        fetch("https://api.usw2.cordial.io/v2/contacts", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${cordialAuth}`,
          },
          body: JSON.stringify(cordialBody),
        })
          .then((response) => {
            if (!response.ok) throw new Error("Network response was not ok");
            return response.json();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", handleCustomerForms);
